import { render } from "./EditShop.vue?vue&type=template&id=024085a6&scoped=true&ts=true&lang=pug"
import script from "./EditShop.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditShop.vue?vue&type=script&setup=true&lang=ts"

import "./EditShop.vue?vue&type=style&index=0&id=024085a6&scoped=true&lang=less"

import exportComponent from "/Users/yangkeneng/Projects/mddh5-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-024085a6"]])

export default __exports__